import React, { useContext } from 'react'

import { FnaContext } from '../../context'
import { Form } from './Form'
import { Show } from './Show'
import { Destroy } from './Delete'

export const DisabilityCoverViews = () => {
  const {
    state: { view }
  } = useContext(FnaContext)

  return (
    {
      create: () => <Form />,
      show: () => <Show />,
      update: () => <Form />,
      delete: () => <Destroy />
    }[view || 'create']()
  )
}
